import map from './map.png';
import healthcareStandart from './healthcare-standart.webp';
import logo from './logo.png';
import baby from './baby.png';
import visa from './visa.png';
import user from './user.png';
import ideal from './ideal.png';
import offers from './offers.png';
import formLogo from './formLogo.png';
import mastercard from './mastercard.png';
import securePayment from './securePayment.png';
import infographics1 from './infographics1.png';
import infographics2 from './infographics2.png';
import infographics3 from './infographics3.png';
import infographics4 from './infographics4.png';
import infographics5 from './infographics5.png';
import infographics6 from './infographics6.png';
import infographics7 from './infographics7.png';
import infographics8 from './infographics8.png';
import fashionTrends from './fashionTrends.png';
import clothesPosition from './clothesPosition.png';

const images = {
  map,
  healthcareStandart,
  logo,
  baby,
  visa,
  user,
  ideal,
  offers,
  formLogo,
  mastercard,
  securePayment,
  infographics1,
  infographics2,
  infographics3,
  infographics4,
  infographics5,
  infographics6,
  infographics7,
  infographics8,
  fashionTrends,
  clothesPosition
};

export default Object.fromEntries(
  Object.entries(images).map(([key, value]) => [key, value.src || value])
);
